<div class="c-loading" [ngClass]="{ 'c-loading--active': status$.active }">
  <div class="c-loading_content">
    <span class="c-loading_loadBox"></span>

    <p class="c-loading_text m-paragraph--medium s-marginTop-md">
      {{ status$.active ? status$.text : textDefault }}
    </p>
  </div>
</div>
